import {Typography, TypographyProps} from "@mui/material";
import {useEffect, useState} from "react";
import {IUsuario} from "@models/conta/IUsuario.ts";
import {useAuth} from "@contexts/hooks/UseAuth.tsx";
import {useUsuario} from "@components/usuario/hooks/useUsuario.ts";

interface UsuarioTypoProps {
    usuarioId: number;
    hideYouFlag?: boolean;
    typographyProps?: TypographyProps;
    displayValue?: (u: IUsuario) => string
}

export function UsuarioTypo(props: UsuarioTypoProps) {
    const {usuarioId, typographyProps, displayValue} = props;
    const {getUsuarios} = useUsuario()
    const {userData} = useAuth()
    const [usuario, setUsuario] = useState<IUsuario | null>(null);

    useEffect(() => {
        getUsuarios({id: [usuarioId]}, {page: 1, pageSize: 1}).then(x => {
            if (x.status === 'Success' && x.items.length > 0) {
                setUsuario(x.items[0]);
            } else {
                setUsuario(null);
            }
        })
    }, [usuarioId]);

    return (usuario != null && <Typography component={'span'}{...typographyProps} >
        {((displayValue != null && displayValue(usuario)) || usuario.nome)}
        {userData?.id == usuario.id && !props.hideYouFlag &&
            <Typography component={"span"} pl={0.5} color={'info'}
                        {...typographyProps} >(você)</Typography>}
    </Typography>)
}

